// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__vgWYQ","tabs":"LayoutWrapperSideNav_tabs__2RKQZ","tab":"LayoutWrapperSideNav_tab__3WYLQ"};